module.exports = {
	"cant": 1,
	"can't": 1,
	"dont": 1,
	"don't": 1,
	"doesnt": 1,
	"doesn't": 1,
	"not": 1,
	"non": 1,
	"wont": 1,
	"won't": 1,
	"isnt": 1,
	"isn't": 1
};


//////////////////
// WEBPACK FOOTER
// ./~/sentiment/languages/en/negators.json
// module id = 2297
// module chunks = 0